import L from "leaflet";

import { TextLayer } from "leaflet-textlayer" //required for L.TextLayer

L.Map.include({
    findParentLayer: function(childLayer) {
        let parent = null;
        this.eachLayer((l) => {
            if (!(l instanceof L.LayerGroup))
                return;

            if (l.hasLayer(childLayer)) {
                parent = l;
                return;
            }
        });

        return parent;
    },
    getZoomPercentage: function() {
        return (100 / (this.getMaxZoom() - this.getMinZoom())) * (this.getZoom() - this.getMinZoom());
    }
});

L.Layer.include({
    addEventListeners: function(component) {
        this.on("pm:edit", e => component.edit(e));
        if (this instanceof L.TextLayer) {
            this.on("click", e => component.blockTextLayerMode());
        }
    },
    removeEventListeners: function (component) {
        this.off("pm:edit", e => component.edit(e));
    },
    addFeatureProperties: function() {
        let tooltip = this.getTooltip();

        if (this.eachLayer) {
            this.eachLayer((l) => l.addFeatureProperties());
        } else if (tooltip) {
            this.feature = this.toGeoJSON();
            if (!this.feature.properties.text)
                this.feature.properties.text = tooltip.getContent();
        }
    },
    isGeometryLayer: function () {
        return this instanceof L.Polyline || //Polyline includes Polygon and Rectangle
            this instanceof L.Marker ||
            this instanceof L.Circle ||
            this instanceof L.CircleMarker ||
            this instanceof L.TextLayer;
    },
    isTemporaryLayer: function() {
        return this._pmTempLayer;
    }
});